import { TopEmotion } from '@/utils/emotion-detector';

/**
 * Wraps an async emotion action with error handling
 * Calls the onSuccess callback only if the action succeeds
 */
export async function handleEmotionAction(
	action: () => Promise<TopEmotion | null>,
	onSuccess: (emotion: TopEmotion) => void,
): Promise<void> {
	try {
		const confirmedEmotion = await action();
		if (confirmedEmotion) {
			onSuccess(confirmedEmotion);
		}
	} catch (error) {
		// Emotion action failed, ignore silently
	}
}
